// Icon imports
import { TiUserAdd } from 'react-icons/ti';
import { RiAdminFill } from 'react-icons/ri';

export const config = {
  // =====================================================================
  // ***************** General *****************
  // =====================================================================

  environment: 'production', // choose "development" or "production"
  appName: 'CoinManufactory',
  appDomain: 'https://admin.coinmanufactory.com',
  serverDomain: 'https://coinmanufactory-platform-kmqsa.ondigitalocean.app',
  roles: ['superuser', 'manager', 'readonly'], // First role should have highest priviliges

  // =====================================================================
  // ***************** Cloudinary *****************
  // =====================================================================
  cloudinary: {
    name: 'dphjpnzr6',
  },

  // =====================================================================
  // ***************** Navigation *****************
  // =====================================================================

  links: {
    navigation: [
      // {
      //   name: 'Email Templates',
      //   link: 'email-templates',
      // },
      // {
      //   name: 'Newsletter Emails',
      //   link: 'newsletter-emails',
      // },
      {
        name: 'Blog',
        link: 'blog',
      },
    ],
    user: [
      {
        name: 'User Requests',
        link: '/user-requests',
        restricted: ['superuser'],
        ReactIcon: TiUserAdd,
      },
      {
        name: 'Admin Users',
        link: '/admin-users',
        restricted: ['superuser'],
        ReactIcon: RiAdminFill,
      },
    ],
  },
};
